// @flow
import { useContext } from 'react';

import { UserContext } from '../contexts/UserContext';
import { getIfUserIsAdminBasedOnGivenDetails } from '../common-utils/utils';

export const useIsUserAdmin = () => {
  const user = useContext(UserContext);
  return getIfUserIsAdminBasedOnGivenDetails(user);
};
